import React, { useEffect, useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import OverviewComponent from './OverviewComponent';
import TransactionComponent from './TransactionComponent';

// Global font setup
const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap');

  * {
    font-family: 'Poppins', sans-serif;
    box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
    background: #fafafa;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 30px 0 10px;
  width: 360px;
`;

const NameOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
`;

const NameForm = styled.div`
  background: white;
  padding: 25px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  width: 80%;
  max-width: 300px;

  & input {
    padding: 10px;
    margin: 10px 0;
    width: 100%;
    border-radius: 5px;
    border: 1px solid #ccc;
    outline: none;
    font-size: 14px;
  }

  & button {
    background: black;
    color: white;
    border: none;
    padding: 8px 15px;
    border-radius: 5px;
    cursor: pointer;
    transition: background 0.2s ease;
  }

  & button:hover {
    background: #333;
  }
`;

const HomeComponent = () => {
  const [transactions, updateTransaction] = useState(() => {
    const saved = localStorage.getItem('transactions');
    return saved ? JSON.parse(saved) : [];
  });

  const [expense, updateExpense] = useState(0);
  const [income, updateIncome] = useState(0);
  const [userName, setUserName] = useState(() => {
    return localStorage.getItem('userName') || '';
  });
  const [tempName, setTempName] = useState('');

  const calculateBalance = (txns) => {
    let exp = 0;
    let inc = 0;
    txns.forEach((payload) => {
      if (payload.type === 'EXPENSE') {
        exp += payload.amount;
      } else {
        inc += payload.amount;
      }
    });
    updateExpense(exp);
    updateIncome(inc);
  };

  useEffect(() => {
    localStorage.setItem('transactions', JSON.stringify(transactions));
    calculateBalance(transactions);
  }, [transactions]);

  const addTransaction = (payload) => {
    const transactionArray = [...transactions, payload];
    updateTransaction(transactionArray);
  };

  const deleteTransaction = (id) => {
    const updatedTransactions = transactions.filter((txn) => txn.id !== id);
    updateTransaction(updatedTransactions);
    localStorage.setItem('transactions', JSON.stringify(updatedTransactions));
  };

  const handleNameSubmit = () => {
    if (tempName.trim()) {
      setUserName(tempName);
      localStorage.setItem('userName', tempName);
    }
  };

  useEffect(() => {
    calculateBalance(transactions);
  }, []);

  return (
    <>
      <GlobalStyle />
      <Container>
        {!userName && (
          <NameOverlay>
            <NameForm>
              <h3>Welcome! What's your name?</h3>
              <input
                placeholder="Enter your name"
                value={tempName}
                onChange={(e) => setTempName(e.target.value)}
              />
              <br />
              <button onClick={handleNameSubmit}>Continue</button>
            </NameForm>
          </NameOverlay>
        )}

        <OverviewComponent
          addTransaction={addTransaction}
          expense={expense}
          income={income}
        />

        <TransactionComponent
          transactions={transactions}
          deleteTransaction={deleteTransaction}
        />

        <footer style={{ marginTop: '40px', color: '#555', fontSize: '14px' }}>
          <p>Welcome {userName || 'Guest'}!</p>
          <p>Made by Salami Folasade Mariam © {new Date().getFullYear()}</p>
        </footer>
      </Container>
    </>
  );
};

export default HomeComponent;
